module.exports = __webpack_public_path__ + "static/media/signup_verifycode_left_img.8984ffd2.svg";